import React, { forwardRef } from 'react';

const Wrap = forwardRef(({ children }, ref) => {
  return (
    <div ref={ref} className="wrap">
      {children}
    </div>
  );
});

Wrap.displayName = 'Wrap';

export default Wrap;
